import { PropsWithChildren } from 'react';

import { RadioGroup } from '@mui/material';
import { RadioGroupProps } from '@mui/material/RadioGroup';
import { Field, FieldProps } from 'react-final-form';

import { RadioContext } from '@cast/design-system';

import { useControlsGroupState } from './controls-state';
import { useRffFormState } from '../hooks';

export type RffRadioGroupProps = PropsWithChildren<{
  name: string;
  fieldProps?: Partial<FieldProps<string, any>>;
  onValuesChanged?: () => void;
  disabled?: boolean;
  testId?: string;
}> &
  Omit<RadioGroupProps, 'name'>;

export const RffRadioGroup = ({
  name: _name,
  fieldProps = {},
  children,
  onValuesChanged,
  disabled: _disabled,
  testId,
  ...radioGroupProps
}: RffRadioGroupProps) => {
  const { mode } = useRffFormState();
  const { disabled, readOnly, name } = useControlsGroupState({
    disabled: _disabled,
    readOnly: mode === 'view' || _disabled,
    name: _name,
  });
  return (
    <RadioContext.Provider value={{ disabled: disabled || readOnly }}>
      <Field
        name={name || _name}
        {...fieldProps}
        render={(p) => {
          const {
            input: { onChange, value },
          } = p;
          return (
            <RadioGroup
              name={name || _name}
              value={value}
              onChange={(_, value) => {
                onChange(value);
                onValuesChanged?.();
              }}
              data-testid={testId}
              {...radioGroupProps}
            >
              {children}
            </RadioGroup>
          );
        }}
      />
    </RadioContext.Provider>
  );
};
